<template>
	<div class="role-sys-tree">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['sys:role:insert']"
					icon="el-icon-plus"
					@click="appendRole"
					>{{ $t("common.add") }}</el-button
				>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				:data="roleList"
				v-loading="loading"
				row-key="id"
				:empty-text="$t('common.noData')"
				:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					prop="sort"
					:label="$t('role.sort')"
					sortable
					:align="'center'"></el-table-column>
				<el-table-column
					prop="name"
					:label="$t('role.name')"
					sortable
					:align="'center'"></el-table-column>

				<el-table-column
					prop="createTime"
					:label="$t('role.createTime')"
					sortable
					:align="'center'"></el-table-column>
				<el-table-column
					:label="$t('common.operate')"
					fixed="right"
					:width="$i18n.locale == 'zh_CN' ? 155 : 155"
					:align="'center'">
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['sys:role:update']"
							@click="modify(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							size="mini"
							v-hasPerm="['sys:role:delete']"
							type="danger"
							@click="remove(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="loadRole"></el-pagination>
		</div>
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="roleStatus ? $t('role.add') : $t('role.edit')"
			:visible.sync="dialogRole"
			width="50%"
			top="9vh"
			@open="openRole"
			@closed="closedRole">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					ref="roleData"
					:label-position="labelPosition"
					:model="roleData"
					label-width="80px">
					<el-row :gutter="20">
						<el-col :span="12" style="margin: 0">
							<el-form-item :label="$t('role.name')" prop="name">
								<el-input
									v-model="roleData.name"
									:placeholder="$t('role.pName')"></el-input>
							</el-form-item>
						</el-col>

						<el-col :span="12" style="margin: 0">
							<el-form-item :label="$t('role.sort')" prop="sort">
								<el-input-number
									v-model="roleData.sort"
									controls-position="right"
									@change="sortChange"
									:min="1"
									:max="10"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogRole = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="addRole('roleData')"
					>{{ $t("common.definite") }}</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
	name: "Role",
	components: { TreeSelect },
	data() {
		return {
			loading: false,
			loadingForm: false,
			dialogRole: false,
			roleStatus: false,
			labelPosition: "top",
			roleData: {
				id: "",
				name: "",
				sort: "",
			},
			roleList: [],
			roleListDialog: [
				{
					id: "1",
					label: this.$t("role.main"),
					children: [],
				},
			],
			page: {
				pageSize: 10,
				pageIndex: 1,
			},

			userTypeList: [],
			userType: "",
			roleTypeList: [],

			disabled: false,
			parentId: 0,

			value: "",
		};
	},
	mounted() {
		let parentId = sessionStorage.getItem("parentId");
		this.parentId = parentId;
		this.loadRole();
		this.listUserType();
		this.listRoleType();
	},
	methods: {
		listUserType() {
			let _self = this;
			_self.$api.dict("sys_user_type").then(res => {
				if (res.code === 0) {
					this.userTypeList = res.data;
				}
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.loadRole();
		},
		// 加载角色信息
		loadRole(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			this.$api
				.request(this.$url.AuthorityRole.load, this.$method.get, {
					type: 0,
					...this.page,
				})
				.then(res => {
					if (res.code === 0) {
						this.roleList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
						this.roleListDialog[0].children = this.roleList;
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		//  加载角色类型
		listRoleType() {
			this.$api.dict("sys_role_type").then(res => {
				if (res.code === 0) {
					let roleTypeList = res.data;
					if (parseInt(this.parentId) > 0) {
						// 非管理员角色：只支持自定义角色不能更改
						this.disabled = true;
						roleTypeList = [];
						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i]["value"] == 0) {
								roleTypeList.push(res.data[i]);
							}
						}
					} else {
						this.disabled = false;
					}
					this.roleTypeList = roleTypeList;
				}
			});
		},

		appendRole() {
			this.roleData.sort = this.roleList.length + 1;
			this.dialogRole = true;
			this.roleStatus = true;
		},
		modify(data) {
			let _self = this;
			_self.roleData.id = data.id;
			_self.roleData.name = data.name;
			_self.roleData.sort = data.sort;
			_self.roleStatus = false;
			_self.dialogRole = true;
		},
		remove(data) {
			let text =
				data.pid === "0" ? this.$t("role.delAll") : this.$t("role.del");
			this.$confirm(text, this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.AuthorityRole.delete, this.$method.delete, {
						id: data.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$message.success(this.$t("role.delS"));
							this.loadRole();
						}
					});
			});
		},
		addRole(role) {
			this.$refs[role].validate(valid => {
				if (valid) {
					let url = this.$url.AuthorityRole.save;
					let method = this.$method.post;
					if (this.roleData.id) {
						url = this.$url.AuthorityRole.update;
						method = this.$method.put;
					}
					this.loadingForm = true;
					this.$api
						.request(url, method, this.roleData)
						.then(res => {
							if (res.code === 0) {
								this.$message.success(this.$t("role.addS"));
								this.dialogRole = false;
								this.loadRole();
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.$message.error(this.$t("role.addE"));
							this.loadingForm = false;
						});
				} else {
					return false;
				}
			});
		},

		delRole(array, data) {
			if (data && data.children) {
				for (let i = 0; i < data.children.length; i++) {
					array.push(data.children[i].id);
					let children = data.children[i];
					if (children.children && children.children.length > 0) {
						this.delRole(children.children);
					}
				}
			}
		},
		userTypeChange(val) {
			if (val === "") {
				this.roleData.name = val;
			} else {
				this.userTypeList.forEach(k => {
					if (k.value === val) {
						this.roleData.name = k.label;

						return true;
					}
				});
			}
		},

		roleType(row) {
			return this.$cloud.getDictLabel(this.roleTypeList, row.roleType);
		},
		openRole() {
			// this.userTypeList.forEach(k => {
			// 	if (k.notes === this.roleData.authName) {
			// 		this.userType = k.value;
			// 		return true;
			// 	}
			// });
		},
		closedRole() {
			this.userType = "";
			this.clearValidate("roleData");
			this.$toolUtil.clearForm(this.roleData);
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style lang="scss">
@import "~@/assets/scss/tree";

.vue-treeselect__placeholder {
	line-height: 40px;
	padding: 0 10px;
}

.vue-treeselect__single-value {
	padding: 0 10px;
	line-height: 40px;
}
</style>
<style>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.el-form-item {
	margin-bottom: 0;
}
</style>
